import React, { Component } from 'react';

import { WrapperFlex } from '@unimed-fesp/components';

import ErrorPage from './pages/ErrorPage';

const { NODE_ENV } = process.env;

class ErrorBoundary extends Component {
  constructor() {
    super();
    this.state = { hasError: false, error: null };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error });
    console.log(error.message, info.componentStack);
  }

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError)
      return (
        <WrapperFlex column justifyCenter alignCenter height={657}>
          <ErrorPage error={error} />
        </WrapperFlex>
      );
    return children;
  }
}

export default ErrorBoundary;
